import React from 'react';
import CourseListItem from 'Views/Pages/Frontend/StudyPlanWizard/StudyPlan/CourseListItem';
import {
	CourseEntity, IGeneratedTermEntityAttributes, StudyPlanEntity,
} from 'Models/Entities';
import {
	RequisiteWarning,
} from 'Queries/Hooks/StudyPlan/types';
import { DataIndex } from 'Util/DataIndexUtils';
import { IconButton } from 'Views/Components/Button/IconButton';
import { toLower } from 'lodash';

interface StudyPlanTermProps {
	termName: string,
	studyPlanId: string,
	requisiteWarningsByCourseId: DataIndex<RequisiteWarning[]>;
	generatedTerm: IGeneratedTermEntityAttributes;
	courses: CourseEntity[];
	maxStudyLoad: number;
	minStudyLoad: number;
	termStudyLoad: number;
	incrementPeriodStudyLoad: (period: number, term: number) => void;
	decrementPeriodStudyLoad: (period: number, term: number) => void;
	getCourseComponents: (courseId: string) => string[];
}

const StudyPlanTerm = (props: StudyPlanTermProps) => {
	const {
		termName,
		requisiteWarningsByCourseId,
		generatedTerm,
		courses,
		maxStudyLoad,
		minStudyLoad,
		termStudyLoad,
		incrementPeriodStudyLoad,
		decrementPeriodStudyLoad,
		getCourseComponents,
	} = props;

	return (
		<>
			<div className="study-term">
				<h6>{termName}</h6>
				<p className="study-load">
					<IconButton
						className={'change-study-load-btn size--sm'}
						icon="minus"
						onClick={() => {
							decrementPeriodStudyLoad(
								generatedTerm.periodOrder,
								generatedTerm.termOrder,
							);
						}}
						disabled={termStudyLoad <= minStudyLoad}
						aria-label="Decrease study load"
					/>
					{termStudyLoad} {toLower(window.lexicon.unitsShort)}
					<IconButton
						className={'change-study-load-btn size--sm'}
						icon="plus"
						onClick={() => {
							incrementPeriodStudyLoad(
								generatedTerm.periodOrder,
								generatedTerm.termOrder,
							);
						}}
						disabled={termStudyLoad >= maxStudyLoad}
						aria-label="Increase study load"
					/>
				</p>
			</div>
			{
				courses.length > 0
					? courses
						.map(course => (
							<CourseListItem
								key={course.id}
								course={course}
								requisiteWarnings={requisiteWarningsByCourseId[course.id]}
								componentNames={getCourseComponents(course.id)}
							/>
						))
					: (
						<div className="study-plan-course empty">
							<p style={{ margin: 'auto' }}>
								No courses
							</p>
						</div>
					)
			}
		</>
	);
};

export default StudyPlanTerm;
